import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import style from './Setting.module.css';
import { Oval } from 'react-loader-spinner';
import { useDispatch, useSelector } from 'react-redux';
import {
  updateUser,
  usernameUpdate,
  userpasswordUpdate,
} from '../../actions/user.action';
import axios from 'axios';
import { Link } from 'react-router-dom';

const Setting = () => {
  const dispatch = useDispatch();
  const [oldPass, setOldPass] = useState('');
  const [code, setCode] = useState('');
  const [twoFA, setTwoFA] = useState({});
  const [newPass, setNewPass] = useState('');
  const [userNameShow, setUserNameShow] = useState(false);
  const [loginhistoryshow, setloginhistoryshow] = useState(false);
  const [loadLoginHistory, setLoadLoginHistory] = useState(false);
  const user = JSON.parse(localStorage.getItem('curUser'));
  const [userPasswordShow, setUserPasswordShow] = useState(false);
  const [loginDetails, setLoginDetails] = useState({});
  const passUpdateState = useSelector((state) => state.userpassUpdateReducer);
  const nameUpdateState = useSelector((state) => state.usernameUpdateReducer);
  const { loading, success, message } = passUpdateState;
  const [username, setUsername] = useState(user.user.name);
  const [isEnabled, setIsEnabled] = useState();

  const updateUsernameHandle = () => {
    if (username) {
      if (username.length < 2) {
        toast.error('Minimum length 2!');
      } else {
        dispatch(usernameUpdate(user.user._id, username));
      }
    } else {
      toast.error('Please fill the required!');
    }
  };

  const verifyTwoFA = async (imageUrl, secret, token) => {
    const res = await axios.post('/user/qrverify', { secret, token });
    if (res.data.verified) {
      dispatch(
        updateUser(user.user._id, {
          twoFactor: res.data.verified,
          qrImage: imageUrl,
          qrSecret: secret,
        })
      );
      setIsEnabled(!isEnabled);
      toast.success('Authentication Enabled!');
      window.location.reload();
    } else toast.error('Enter valid code!');
    setCode('');
  };

  const disableTwoFA = async (secret, token) => {
    const res = await axios.post('/user/qrverify', { secret, token });
    if (res.data.verified) {
      dispatch(
        updateUser(user.user._id, {
          twoFactor: false,
          qrImage: '',
          qrSecret: '',
        })
      );
      setIsEnabled(!isEnabled);
      toast.success('Authentication Disable!');
      window.location.reload();
    } else toast.error('Enter valid code!');
    setCode('');
  };

  const updatePasswordHandle = () => {
    if (oldPass && newPass) {
      if (newPass.length < 6) {
        toast.error('Password min length 6!');
      } else {
        const data = {
          oldPass,
          newPass,
        };
        dispatch(userpasswordUpdate(user.user._id, data));
        setOldPass('');
        setNewPass('');
      }
    } else {
      toast.error('Please fill the required!');
    }
  };

  if (!nameUpdateState.loading && nameUpdateState.success) {
    toast.success('Username Updated!');
  } else if (
    nameUpdateState.loading === false &&
    nameUpdateState.success === false
  ) {
    toast.error(message);
  }

  if (!loading && success) {
    toast.success('Password Updated!');
  } else {
    toast.error(message);
  }

  const [load, setLoad] = useState(true);
  const getloginDetails = async (id) => {
    await axios
      .get(`/loginhistory/${id}`, {
        headers: { 'Access-Control-Allow-Origin': '*' },
        withCredentials: true,
      })
      .then((res) => {
        setLoginDetails(res.data);
        setLoadLoginHistory(true);
        setIsEnabled(res.data.userLoginHistory.twoFactor);
        setLoad(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    getloginDetails(user.user._id);
    async function fetchData() {
      await axios.get('/user/qrcode').then((res) => setTwoFA(res.data));
    }
    fetchData();
  }, []);

  return (
    <div className={style.Setting}>
      <p>Setting</p>
      {!load ? (
        <div style={{ backgroundColor: '#262626', borderRadius: '5px' }}>
          <div className={style.Email}>
            <p>Email</p>
            <p style={{ color: 'rgb(165, 171, 177)' }}>{user.user.email}</p>
          </div>
          <div className={style.Username}>
            <div className={style.Flex}>
              <p>Username</p>
              {!userNameShow ? (
                <div
                  onClick={() => setUserNameShow(!userNameShow)}
                  className={style.Button}
                >
                  Change
                </div>
              ) : null}
            </div>
            {userNameShow ? (
              <div className={style.username_bottom}>
                <input
                  placeholder='Username'
                  type='text'
                  value={username}
                  onChange={(e) => {
                    e.preventDefault();
                    setUsername(e.target.value);
                  }}
                />
                <div>
                  <div
                    onClick={() => setUserNameShow(!userNameShow)}
                    className={style.ButtonDark}
                  >
                    Cancel
                  </div>
                  <div
                    onClick={updateUsernameHandle}
                    className={`${
                      username !== user.user.name
                        ? style.ButtonDark
                        : style.ButtonDisable
                    }`}
                  >
                    Update
                  </div>
                </div>
              </div>
            ) : null}
          </div>
          <div className={style.Password}>
            <div className={style.Flex}>
              <p>Password</p>
              {!userPasswordShow ? (
                <div
                  onClick={() => setUserPasswordShow(!userPasswordShow)}
                  className={style.Button}
                >
                  Change
                </div>
              ) : null}
            </div>
            {userPasswordShow ? (
              <div className={style.username_bottom}>
                <input
                  value={oldPass}
                  onChange={(e) => setOldPass(e.target.value)}
                  placeholder='Old Password'
                  type='password'
                />
                <input
                  value={newPass}
                  onChange={(e) => setNewPass(e.target.value)}
                  placeholder='New Password'
                  type='password'
                />
                <div>
                  <div
                    onClick={() => setUserPasswordShow(!userPasswordShow)}
                    className={style.ButtonDark}
                  >
                    Cancel
                  </div>
                  <div
                    onClick={updatePasswordHandle}
                    className={style.ButtonDark}
                  >
                    Update
                  </div>
                </div>
              </div>
            ) : null}
          </div>
          <div className={style.kyc}>
            <div className={style.Flex}>
              <p>KYC</p>
              <Link to='/kyc'>
                <div className={style.Button}>Verify</div>
              </Link>
            </div>
          </div>
          <div className={style.Username}>
            <div className={style.Flex}>
              <p>Two Factor Authentication</p>
              <div
                onClick={() => setIsEnabled(!isEnabled)}
                className={style.Button}
              >
                {isEnabled ? 'Hide' : 'Show'}
              </div>
            </div>
            {isEnabled ? (
              <div>
                {twoFA && (
                  <div>
                    {loginDetails.userLoginHistory.qrImage ? (
                      <img
                        style={{ marginTop: '10px' }}
                        src={loginDetails.userLoginHistory.qrImage}
                      />
                    ) : (
                      <img style={{ marginTop: '10px' }} src={twoFA.data} />
                    )}
                    <div className={style.username_bottom}>
                      <input
                        maxLength={6}
                        value={code}
                        onChange={(e) => setCode(e.target.value)}
                        placeholder='Enter Code'
                        type='text'
                      />
                      <div>
                        {loginDetails.userLoginHistory.qrImage ? (
                          <div
                            onClick={() => {
                              disableTwoFA(
                                loginDetails.userLoginHistory.qrSecret,
                                code
                              );
                            }}
                            className={style.ButtonDark}
                          >
                            Disable
                          </div>
                        ) : (
                          <div
                            onClick={() => {
                              verifyTwoFA(twoFA.data, twoFA.secret.ascii, code);
                            }}
                            className={style.ButtonDark}
                          >
                            Verify
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ) : null}
          </div>
          <div className={style.LoginHistoryContainer}>
            <div className={style.Flex}>
              <p>
                Login History{' '}
                <span style={{ fontSize: '12px', color: 'rgb(236, 195, 236)' }}>
                  (Last 5)
                </span>
              </p>
              <div
                onClick={() => {
                  setloginhistoryshow(!loginhistoryshow);
                  !loginhistoryshow ? (
                    getloginDetails(user.user._id)
                  ) : (
                    <div></div>
                  );
                }}
                className={style.Button}
              >
                {loginhistoryshow ? 'Cancel' : 'Show'}
              </div>
            </div>
            {loginhistoryshow ? (
              <div>
                <div className={style.TableHead}>
                  <div>Date</div>
                  <div>IP</div>
                  <div>Location</div>
                  <div>Browser</div>
                  <div>OS</div>
                </div>
                <div>
                  {loadLoginHistory &&
                    loginDetails.userLoginHistory.loginHistory
                      .map((his) => {
                        let date = new Date(his.createdAt).toString();
                        const result = date.split(' ');
                        const newDate = `${result[2]}/${result[1]}/${result[3]}`;
                        const newTime = result[4];

                        return (
                          <div className={style.TableData} key={his._id}>
                            <div className={style.TimeDate}>
                              <div className={style.Date}>{newDate}</div>
                              <div
                                className={style.Time}
                              >{`Time - ${newTime}`}</div>
                            </div>
                            <div>{his.loginHistory.ip}</div>
                            <div>{`${his.loginHistory.location}-${his.loginHistory.country}`}</div>
                            <div>{his.loginHistory.browserName}</div>
                            <div>{his.loginHistory.os}</div>
                          </div>
                        );
                      })}
                </div>
              </div>
            ) : (
              <div></div>
            )}
            {/* <div className={style.Flex}>
            <div className={style.LoginHistoryDate}>
              <p>Date</p>
              <p>1 week ago</p>
            </div>
            <div className={style.LoginHistoryDate}>
              <p>Username</p>
              <p>Singh</p>
            </div>
            <div className={style.LoginHistoryDate}>
              <p>IP</p>
              <p>192.168.0.1</p>
            </div>
            <div className={style.LoginHistoryDate}>
              <p>Location</p>
              <p>Nangloi-IN</p>
            </div>
            <div className={style.LoginHistoryDate}>
              <p>Browser</p>
              <p>Chrome</p>
            </div>
            <div className={style.LoginHistoryDate}>
              <p>OS</p>
              <p>Windows 10</p>
            </div>
          </div> */}
          </div>
        </div>
      ) : (
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '50px' }}>
          <Oval
            ariaLabel='loading-indicator'
            height={80}
            width={80}
            strokeWidth={5}
            color='white'
            secondaryColor='purple'
          />
        </div>
      )}
    </div>
  );
};

export default Setting;
